'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lsamples_ConditionalSample(person) {
  this.mj = null;
  this.mj = person;
}
export { $c_Lsamples_ConditionalSample as $c_Lsamples_ConditionalSample };
$p = $c_Lsamples_ConditionalSample.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lsamples_ConditionalSample;
/** @constructor */
function $h_Lsamples_ConditionalSample() {
}
export { $h_Lsamples_ConditionalSample as $h_Lsamples_ConditionalSample };
$h_Lsamples_ConditionalSample.prototype = $p;
$p.I = (function() {
  return new $j_java$002elang$002e$002dObject.$c_s_Product$$anon$1(this);
});
$p.m = (function() {
  return $j_java$002elang$002e$002dObject.$m_s_util_hashing_MurmurHash3$().av(this, (-2008011664), true);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsamples_ConditionalSample)) {
    var x = this.mj;
    var x$2 = x$0.mj;
    return ((x === null) ? (x$2 === null) : x.f(x$2));
  } else {
    return false;
  }
});
$p.b = (function() {
  return $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().ah(this);
});
$p.n = (function() {
  return 1;
});
$p.o = (function() {
  return "ConditionalSample";
});
$p.g = (function(n) {
  if ((n === 0)) {
    return this.mj;
  }
  throw $j_java$002elang$002e$002dObject.$ct_jl_IndexOutOfBoundsException__I__(new $j_java$002elang$002e$002dObject.$c_jl_IndexOutOfBoundsException(), n);
});
function $isArrayOf_Lsamples_ConditionalSample(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.e9)));
}
export { $isArrayOf_Lsamples_ConditionalSample as $isArrayOf_Lsamples_ConditionalSample };
var $d_Lsamples_ConditionalSample = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lsamples_ConditionalSample, "samples.ConditionalSample", ({
  e9: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lsamples_ConditionalSample as $d_Lsamples_ConditionalSample };
